import axios from "axios";

const API_URL = "/api/classrooms";

export const getClassRooms = async () => {
  try {
    const { data } = await axios.get(API_URL);
    
    return data;

  } catch (error) {
    console.error("Error fetching classrooms:", error);
    throw error;
  }
};

export const addClassRoom = async (payload) => {
  console.log("Adding classroom:", payload);
  try {
    const { data } = await axios.post(API_URL, payload);
    console.log("Added classroom:", data);
    
    return data;
  } catch (error) {
    console.error("Error adding classroom:", error);
    throw error;
  }
};

export const editClassRoom = async (id, payload) => {
  try {
    const { data } = await axios.put(`${API_URL}/${id}`, payload);
    return data;
  } catch (error) {
    console.error(`Error editing classroom ${id}:`, error);
    throw error;
  }
};

export const deleteClassRoom = async (id) => {
  try {
    const { data } = await axios.delete(`${API_URL}/${id}`);
    return data;
  } catch (error) {
    console.error(`Error deleting classroom ${id}:`, error);
    throw error;
  }
};
